/**
 * Shared context for the processing pipeline
 * Tracks statistics, warnings, and state during processing
 */
export class PipelineContext {
  private warnings: string[] = [];
  private wordCount: number = 0;
  private imageCount: number = 0;
  private startTime: number;

  constructor() {
    this.startTime = Date.now();
  }

  /**
   * Add a warning message
   */
  addWarning(message: string): void {
    this.warnings.push(message);
  }

  /**
   * Get all warnings
   */
  getWarnings(): string[] {
    return [...this.warnings];
  }

  /**
   * Set word count
   */
  setWordCount(count: number): void {
    this.wordCount = count;
  }

  /**
   * Get word count
   */
  getWordCount(): number {
    return this.wordCount;
  }

  /**
   * Increment image count
   */
  incrementImageCount(): void {
    this.imageCount++;
  }

  /**
   * Get image count
   */
  getImageCount(): number {
    return this.imageCount;
  }

  /**
   * Get processing statistics
   */
  getStats() {
    return {
      duration: Date.now() - this.startTime,
      wordCount: this.wordCount,
      imageCount: this.imageCount,
      warningCount: this.warnings.length,
    };
  }

  /**
   * Reset context for new processing
   */
  reset(): void {
    this.warnings = [];
    this.wordCount = 0;
    this.imageCount = 0;
    this.startTime = Date.now();
  }
}
